import { useEffect, useReducer } from "react";

import { getClient } from "../client";
import { DM_TYPE, channelOptsEverything } from "../constants";
import { flattenRawChannel, registerRawChannel } from "../entities/channels";
import { connectedAsUser } from "../state";

async function fetchChannelByUserIds(loggedInUser, userIds) {
  const filter = {
    type: DM_TYPE,
    community: loggedInUser.community,
    members: { $eq: [loggedInUser.id, ...userIds] },
  };

  const rawChannels = await getClient().queryChannels(
    filter,
    {},
    {
      ...channelOptsEverything,
      limit: 1,
    }
  );
  if (rawChannels && rawChannels.length > 0) {
    const rawChannel = rawChannels[0];
    registerRawChannel(rawChannel, channelOptsEverything, false);
    return flattenRawChannel(rawChannel);
  }
  return null;
}

function reducer(state, mergeState) {
  return { ...state, ...mergeState };
}

export default function useChannelByUsers({ userIds }) {
  const user = connectedAsUser.use();
  const [state, dispatch] = useReducer(reducer, {
    channel: null,
    error: null,
    loading: false,
  });

  useEffect(() => {
    async function getChannelByUserIds() {
      dispatch({ channel: null, error: null, loading: true });
      try {
        const channel = await fetchChannelByUserIds(user, userIds);
        dispatch({ channel, error: null, loading: false });
      } catch (error) {
        dispatch({ error, loading: false });
      }
    }

    if (userIds.length > 0) {
      getChannelByUserIds();
    }
  }, [user, userIds]);

  return state;
}
